module.exports = __webpack_public_path__ + "23e0f0d5e572e4c879424b18579185bf.pdf";